import React from "react"
import { type ReservationDetailsStepProps } from "./shared"
import ReservationDetailsStepDesktop from "./desktop"
import ReservationDetailsStepMobile from "./mobile"

const ReservationDetailsStep: React.FC<ReservationDetailsStepProps> = (props) => {
  if (props.mobileSheet) {
    return <ReservationDetailsStepMobile {...props} />
  }
  return <ReservationDetailsStepDesktop {...props} />
}

export default ReservationDetailsStep
